import * as TYPES from '../types'
import api from '../../api'

const state = {
  selector: {
    headers: [],
    items: [],
    selectedHeader: '',
    selectedItems: []
  },
  all: [],
  hot: []
}

const mutations = {
  [TYPES.RESET_FLAWS_SELECTOR](state) {
    state.selector.selectedItems = []
  },
  [TYPES.ON_GET_ALL_FLAWS](state, data) {
    state.all = data
  },
  [TYPES.ON_GET_FLAWS_SELECTOR_HEADERS](state, data) {
    state.selector.headers = data
  },
  [TYPES.ON_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER](state, data) {
    state.selector.items = data
  }
}

const actions = {
  [TYPES.ORDER_FLAWS]({commit}, items) {
    return new Promise((resolve, reject) => {
      api.ORDER_FLAWS(items)
      .then(res => {
        resolve(res)
      })
      .catch(res => {
        reject(res)
      })
    })
  },
  [TYPES.DO_GET_ALL_FLAWS]({ commit }) {
    return new Promise(function(resolve, reject) {
      api
        .DO_GET_ALL_FLAWS()
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_ALL_FLAWS, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_FLAWS_SELECTOR_HEADERS]({ commit }) {
    return new Promise(function(resolve, reject) {
      api
        .DO_GET_FLAWS_SELECTOR_HEADERS()
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_FLAWS_SELECTOR_HEADERS, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER]({ commit }, header) {
    return new Promise(function(resolve, reject) {
      api
        .DO_GET_FLAWS_SEARCH_BY_SELECTOR_HEADER(header)
        .then(res => {
          if (res.data.ok) {
            commit(TYPES.ON_GET_FLAWS_BY_SEARCH_SELECTOR_HEADER, res.data.data)
            resolve(res)
          } else {
            reject(res)
          }
        })
        .catch(res => {
          reject(res)
        })
    })
  },
  [TYPES.DO_ADD_FLAW]({commit}, flaw) {
    return new Promise((resolve, reject) => {
      api.DO_ADD_FLAW(flaw)
      .then(res => {
        if (res.data.ok) {
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(res => {
        reject(res)
      })
    })
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/flaws.js